import * as React from 'react'
import cn from 'classnames'
import styles from './EntityCard.module.scss'
import { PropsWithRequiredChildren } from '../../../types/helpers'

export type FooterProps = PropsWithRequiredChildren<
  React.ComponentPropsWithoutRef<'div'>
>

export const Footer: React.VFC<FooterProps> = (props) => {
  const { className, children, ...restProps } = props

  return (
    <div className={cn(styles.footer, className)} {...restProps}>
      {children}
    </div>
  )
}
